// extracted by mini-css-extract-plugin
export var chevron = "_mv-3";
export var chevronRotated = "_mv-4";
export var image = "_mv-1";
export var imageContainer = "_mv-0";
export var shippingAddress = "_mv-2";